import { Injectable } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class AppLink {
  public resourceId: number;
  public name: string;
  public link: string;
  public iconUrl: string;
  public order: number;
  public group: number;
  public showAsNew: boolean;
  public newTextOverride: string;
  public hide: boolean;
}

export class AppLinksCfg {
  public appLinks: AppLink[];
}

@Injectable({
  providedIn: 'root'
})
export class AppLinksCfgService extends CfgService<AppLinksCfg> {
  json: any = {
    appLinks: [
      {
        resourceId: 199,
        showAsNew: false,
        name: "Clientes",
        link: "%{ClientsApiUrl}",
        iconUrl: "assets/appLinks/clients@2x.png",
        order: 1,
        group: 0
      },
      {
        resourceId: 3946,
        showAsNew: false,
        name: "Entidades",
        link: "%{ClientsApiUrl}",
        iconUrl: "assets/appLinks/clients@2x.png",
        order: 1,
        group: 0
      },
      {
        resourceId: 205,
        showAsNew: false,
        name: "Focus Talent Group",
        link: "%{BucketsApiUrl}",
        iconUrl: "assets/appLinks/buckets@2x.png",
        order: 4,
        group: 1
      },
      {
        resourceId: -3,
        showAsNew: false,
        name: "relevate talent search (eureka)",
        link: "%{EurekaApiUrl}",
        iconUrl: "assets/appLinks/eureka@2x.png",
        order: 6,
        group: 1
      },
      {
        resourceId: 233,
        showAsNew: false,
        name: "relevate talent assessment (ADN)",
        link: "%{AdnApiUrl}",
        iconUrl: "assets/appLinks/adn@2x.png",
        order: 8,
        group: 1
      },
      {
        resourceId: 2521,
        showAsNew: false,
        name: "relevate reference",
        link: "%{ReferencesApiUrl}",
        iconUrl: "assets/appLinks/references@2x.png",
        order: 9,
        group: 1
      },
      {
        resourceId: 2989,
        showAsNew: false,
        name: "relevate match (ofrecimientos/shortlist)",
        link: "%{TruefitApiUrl}/offering",
        iconUrl: "assets/appLinks/ofrecimientos@2x.png",
        order: 10,
        group: 1
      },
      {
        resourceId: 197,
        showAsNew: false,
        name: "Job Postings",
        link: "%{OffersApiUrl}",
        iconUrl: "assets/appLinks/offers@2x.png",
        order: 12,
        group: 1
      },
      {
        resourceId: 499,
        showAsNew: false,
        name: "Trabajadores",
        link: "%{WorkersApiUrl}",
        iconUrl: "assets/appLinks/workers@2x.png",
        order: 13,
        group: 1
      },
      {
        resourceId: 2602,
        showAsNew: false,
        name: "Nóminas",
        link: "%{PayrollsApiUrl}",
        iconUrl: "assets/appLinks/payrolls@2x.png",
        order: 14,
        group: 1
      },
      {
        resourceId: 3212,
        showAsNew: false,
        name: "Boletines",
        link: "%{TimesheetsFrontUrl}/field",
        iconUrl: "assets/appLinks/massiveBulletinsClosing@2x.png",
        order: 15,
        group: 0
      },
      {
        resourceId: 1956,
        showAsNew: false,
        name: "Facturación",
        link: "%{InvoicingApiUrl}",
        iconUrl: "assets/appLinks/billing@2x.png",
        order: 16,
        group: 0
      },
      {
        resourceId: 200,
        showAsNew: false,
        name: "Informes",
        link: "%{ReportFrontUrl}",
        iconUrl: "assets/appLinks/reports@2x.png",
        order: 18,
        group: 2
      },
      {
        resourceId: 533,
        showAsNew: false,
        name: "Gesfico",
        link: "%{GesficoApiUrl}",
        iconUrl: "assets/appLinks/gesfico@2x.png",
        order: 20,
        group: 4
      },
      {
        resourceId: 2455,
        showAsNew: false,
        name: "Visitas",
        link: "%{VisitsFrontUrl}",
        iconUrl: "assets/appLinks/visits@2x.png",
        order: 23,
        group: 0
      },
      {
        resourceId: 3671,
        showAsNew: false,
        name: "Plataformas",
        link: "%{PlatformsFrontUrl}",
        iconUrl: "assets/appLinks/platforms@2x.png",
        order: 24,
        group: 3
      },
      {
        resourceId: 3726,
        showAsNew: false,
        name: "BBVA",
        link: "%{BbvaFrontUrl}",
        iconUrl: "assets/appLinks/bbva@2x.png",
        order: 25,
        group: 0
      },
      {
        resourceId: 3900,
        showAsNew: false,
        name: "Proyectos",
        link: "%{TenderFrontUrl}",
        iconUrl: "assets/appLinks/tenders@2x.png",
        order: 26,
        group: 0
      },
      {
        resourceId: 7198,
        showAsNew: false,
        name: "Contacta",
        link: "%{ContactaFrontUrl}",
        iconUrl: "assets/appLinks/contacta@2x.png",
        order: 27,
        group: 1
      },
      {
        resourceId: 7274,
        showAsNew: false,
        name: "Vacantes",
        iconUrl: "assets/appLinks/vacants@2x.png",
        order: 28,
        group: 3
      }
    ]
  };

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  public async initialize(): Promise<void> {
    await super.initialize();

    this.data.appLinks = this.data.appLinks.filter(x => !x.hide);
  }

  protected getCfgFile(): string {
    return `/cfg/appLinks.cfg.json`;
  }

  /**
   * Carga las url en el json
   */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
